<template lang="pug">
form(class='tools' ref='form')
  //-
  //- v-tooltip(right)
  //-   | Загрузить схему
  //-   v-btn(
  //-     :class='{ pressed: getActiveState(buttons.upload) }'
  //-     :disabled='getInactiveState(buttons.upload)'
  //-     slot='activator'
  //-     icon
  //-     )
  //-       v-icon image
  //-       input(class='upload' type='file' @change='handler(buttons.upload, $event)')
  //-
  v-tooltip(right)
    v-btn(
      :class='{ pressed: getActiveState(buttons.create) }'
      :disabled='getInactiveState(buttons.create)'
      @click='handler(buttons.create, $event)'
      slot='activator'
      icon
    )
      v-icon create
    | Создать обводку
  //-
  v-tooltip(right)
    v-btn(
      :class='{ pressed: getActiveState(buttons.resize) }'
      :disabled='getInactiveState(buttons.resize)'
      @click='handler(buttons.resize, $event)'
      slot='activator'
      icon
    )
      v-icon photo_size_select_large
    | Изменить размер ViewBox
  //-
  //- v-tooltip(right)
  //-   v-btn(
  //-     :class='{ pressed: getActiveState(buttons.save) }'
  //-     :disabled='getInactiveState(buttons.save)'
  //-     @click='handler(buttons.save, $event)'
  //-     slot='activator'
  //-     icon
  //-   )
  //-     v-icon save
  //-   | Сохранить
  //-
  v-tooltip(right)
    v-btn(
      :class='{ pressed: getActiveState(buttons.remove) }'
      :disabled='getInactiveState(buttons.remove)'
      @click='handler(buttons.remove, $event)'
      slot='activator'
      icon
    )
      v-icon delete_outline
    | Удалить выбранный элемент
</template>

<script>
export default {
  props: {
    buttons: {
      type: Object,
      required: true
    },

    activeStates: {
      type: Object,
      default: () => ({})
    },

    inactiveStates: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {
    handler(name, event) {
      this.$emit('click', { name, event })

      if (this.buttons.upload === name) {
        this.$refs.form.reset()
      }
    },

    getActiveState(name) {
      return this.activeStates[name]
    },

    getInactiveState(name) {
      return this.inactiveStates[name]
    }
  }
}
</script>

<style lang="scss" scoped>
.tools {
  display: flex;
  padding: 9px;
  flex-direction: column;
  & /deep/ {
    .v-btn {
      overflow: hidden;
      & * {
        transition: none;
      }
    }
    .pressed {
      &:before {
        background: #6db722;
      }
    }
  }
}
.upload-wrap {
  overflow: hidden;
}
.upload {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  font-size: 100px;
  opacity: 0;
  cursor: pointer;
}
.upload::-webkit-file-upload-button {
  display: none;
}
</style>
